<div class="mat-mdc-notch-piece mdc-notched-outline__leading"></div>
<div class="mat-mdc-notch-piece mdc-notched-outline__notch" #notch>
  <ng-content></ng-content>
</div>
<div class="mat-mdc-notch-piece mdc-notched-outline__trailing"></div>
